module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/the Hidden Good-6b94d2c7cb0b87ea404c77bca58d394f.png";